export enum StationFiltersQueryNames {
    COMPANY = 'company_id',
    STORE_GROUP = 'store_group_id',
    STORE = 'store_id',
}
